import Calendar from 'presentation/shared/components/Calendar'
import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  ${({ theme }) => css`
    max-width: 1168px;
    min-width: 1157px;
    width: auto;
    margin: auto;
    padding: 1em 1em 1em 1em;
    background-color: ${theme.colors.white};
    border-radius: ${theme.border.radius.small};
  `}
`

export const CardWrapper = styled.div`
  width: auto;
  max-width: 1168px;
  height: auto;
  border: 1px solid #82cec9;
  border-radius: 16px;
  margin: auto;
  display: block;
  padding: 24px 40px;
  margin-bottom: 40px;
`

export const TabWrapper = styled.div`
  width: 100%;
`

export const StatusTag = styled.div`
  width: 160px;
  height: 44px;
  margin: 0;

  display: flex;
  justify-content: center;

  background: ${({ theme }) => theme.colors.brightOrange};
  border-radius: 24px;

  span {
    font-style: normal;
    font-weight: ${({ theme }) => theme.font.bold};
    font-size: ${({ theme }) => theme.font.sizes.small};
    line-height: 28px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #ffffff;
    padding: 3px 0;
  }
`
export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;

  strong {
    font-weight: ${({ theme }) => theme.font.bold};
    font-size: ${({ theme }) => theme.font.sizes.large};
    line-height: 28px;
  }
`

export const CardBody = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
`

export const CardFooter = styled.div`
  display: flex;
  justify-content: space-between;
`

export const SurgeryTitle = styled.h1`
  font-style: normal;
  font-weight: ${({ theme }) => theme.font.bold};
  font-size: ${({ theme }) => theme.font.sizes.large};
  line-height: 48px;
  color: ${({ theme }) => theme.colors.brightOrange};
  flex: none;
  margin-bottom: 24px;
`
export const Strong = styled.strong`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.gray};
  font-weight: ${({ theme }) => theme.font.bold};
  font-size: ${({ theme }) => theme.font.sizes.medium};
  line-height: 28px;
`

export const GreenStrong = styled.strong`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.primary};
  font-size: ${({ theme }) => theme.font.sizes.medium};
  font-weight: ${({ theme }) => theme.font.bold};
  line-height: 28px;
`

export const GreenLabel = styled.h2`
  color: ${({ theme }) => theme.colors.primary};
  font-size: ${({ theme }) => theme.font.sizes.large};
  font-weight: ${({ theme }) => theme.font.semiBold};
  line-height: 32px;
  margin-bottom: 20px;
`

export const TextDescription = styled.span`
  color: ${({ theme }) => theme.colors.gray};
  font-size: ${({ theme }) => theme.font.sizes.small};
  font-weight: ${({ theme }) => theme.font.normal};
  line-height: 27px;
  /* margin-bottom: 20px; */
`

export const OrderContainer = styled.div`
  ${({ theme }) => css`
    max-width: 1168px;
    width: auto;
    height: auto;
    margin: auto;
    padding: 0em 0 1em 0;
    background-color: ${theme.colors.white};
    display: block;
  `}

  textarea {
    border: 1px solid ${({ theme }) => theme.colors.softGray};
  }

  .text {
    border: 1px solid ${({ theme }) => theme.colors.softGray};
  }

  hr {
    margin-top: 12px;
    margin-bottom: 12px;
    border: 0;
    height: 0;
    border-top: 1px #dadee2;
    border-bottom: 1px solid #dadee2;
  }
`

export const SubTitle = styled.label`
  color: ${({ theme }) => theme.colors.black};
  font-size: ${({ theme }) => theme.font.sizes.medium};
  font-weight: ${({ theme }) => theme.font.semiBold};
  display: flex;
  margin-bottom: 9px;
`

export const CheckboxWrapper = styled.div`
  display: flex;
  margin-bottom: 8px;
`

export const ProfileWrapper = styled.div`
  display: grid;
  grid-template-columns: 3fr 1.3fr;
  gap: 63px;
`

export const InputBlock = styled.div`
  margin-bottom: 20px;

  textarea {
    border: 1px solid ${({ theme }) => theme.colors.softGray};
  }

  #email {
    max-width: 752px;
  }

  #fone {
    max-width: 376px;
  }
`

export const PasswordWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  /* align-items: flex-end; */
  gap: 40px;
  margin-bottom: 32px;
`

export const CustomTable = styled.table`
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 40px;
  color: ${({ theme }) => theme.colors.gray};

  .button {
    color: ${({ theme }) => theme.colors.primary};
    font-size: ${({ theme }) => theme.font.sizes.medium};
    font-weight: ${({ theme }) => theme.font.bold};
    text-decoration: underline;
    cursor: pointer;
  }

  .hasButton {
    width: 110px;
    svg {
      cursor: pointer;
    }
  }

  th,
  tr {
    width: 616px;
    height: 48px;
  }

  th {
    background-color: ${({ theme }) => theme.colors.lightPrimary};
    padding: 8px;

    color: ${({ theme }) => theme.colors.primary};
  }

  tr:nth-child(even) {
    background-color: ${({ theme }) => theme.colors.neutralWhite};
  }

  tr {
    box-shadow: inset 0px -1px 0px #ededef;
  }

  td {
    text-align: center;
    padding: 8px;
  }
`

export const BallSpan = styled.span<{ redTag?: boolean }>`
  ${({ redTag }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
    padding: 16px 8px;
    border-radius: 10px;
    width: 19px;
    height: 10px;
    background-color: ${({ theme }) => !!redTag && theme.ds.colors.danger100};
    color: ${({ theme }) => !!redTag && theme.ds.colors.danger900};
  `}
`

export const RadioContainer = styled.div`
  label {
    line-height: normal;
  }
`

export const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 32px;
`

export const EditedBy = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  > .profile {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
    color: ${({ theme }) => theme.ds.colors.white};
    font-weight: ${({ theme }) => theme.ds.typography.weight.bold};
    background-color: ${({ theme }) => theme.ds.colors.primary400};
  }

  > .infos {
    display: flex;
    flex-direction: column;
    color: ${({ theme }) => theme.ds.colors.neutral900};

    .author {
      font-size: ${({ theme }) => theme.ds.typography.size.small};
    }

    .details {
      .role,
      .date {
        font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
        font-weight: ${({ theme }) => theme.ds.typography.weight.bold};
        color: ${({ theme }) => theme.ds.colors.neutral700};
      }

      .role {
        text-transform: uppercase;
      }

      .date {
        color: ${({ theme }) => theme.ds.colors.primary900};
      }
    }
  }
`

export const Buttons = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

export const ModalProcedureContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px;
  gap: 24px;

  position: relative;
  width: 363px;
  height: 248px;

  background: #ffffff;
  border-radius: 16px;
`

export const LineDivider = styled.hr`
  height: 0px;
  border: 1px solid #dadee2;
  background: #dadee2;
  margin-top: 12px;
  width: 100%;
  margin-bottom: 12px;
`

export const ModalButtons = styled.div`
  display: flex;
  justify-content: right;
  gap: 30px;

  button {
    width: 101px;
  }
`

export const AddItemTable = styled.div`
  margin-top: 13px;
`

////////////////////
///////////////////

export const Inputs = styled.div`
  margin-bottom: 24px;
  display: grid;
  grid-template-columns: 1fr 2fr 0.95fr;
  align-items: flex-end;
  justify-content: space-between;

  .description {
    max-width: 480px;
    margin-left: 20px;
  }
`

export const InputButtonContainer = styled.div`
  button {
    position: absolute;
    width: 51px;
    height: 55px;
    display: flex;
    justify-content: center;
    align-content: center;
    margin-left: 4px;
    border-radius: 0px 10px 10px 0px;
    background: ${({ theme }) => theme.colors.primary};

    span {
      width: 30px;
      height: 30px;
    }

    svg {
      height: 30px;
      width: 30px;

      path {
        height: 30px;
        width: 30px;
        fill: white;
        opacity: 1;
      }
    }
  }
`

export const QuantityContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0px 0px 0px 20px;

  input {
    width: 58px;
    padding: 0;
    margin: 0;
    text-align: center;
  }

  h5 {
    margin-right: 10px;
  }
`

export const Title = styled.h5`
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.large};
    font-weight: 400;
    color: ${theme.colors.gray};
    cursor: pointer;
  `}
`

export const StyledCalendar = styled(Calendar)<{ show?: boolean }>`
  position: absolute;
  width: 20em;
  display: ${({ show }) => (show ? 'block' : 'none')};
`

export const AuthorizedSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const EditButtonContainer = styled.div`
  display: flex;
  position: relative;
  top: 22px;
  gap: 20px;
  button {
    display: flex;
    align-self: flex-end;
    justify-content: space-between;
    padding: 15px;
    margin-left: auto;

    svg {
      margin-right: 10px;
    }
  }
`

export const AccordionTab = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: space-between;

  gap: 30px;
  div {
    display: flex;
    gap: 5px;
  }
  width: 100%;
  padding: 0px;
  margin: 0px;
`

export const LineAccordionDivider = styled.div`
  border: 1 solid #dadee2;
  background: #dadee2;
  width: 100%;
  height: 1px;
`
